import React, { memo } from 'react';
import { Linkedin, Twitter, Mail } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
export function TeamSection() {
  const teamMembers = [{
    name: 'Dan Knight',
    role: 'Co-Founder & CEO',
    bio: "Dan is a software engineer turned event operator. After years building products at high-growth startups, he ran events as a go-to-market motion and saw how often small agencies wanted to offer events but could not justify an events team. He realized agencies didn't need to hire. They needed a full-service events team they could plug in. So he built Turnout.",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/puQfL52NJjm2xZfDkLctHA/1744810493288_%281%29.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/dan-c-knight/',
      twitter: 'https://x.com/turnout_info',
      email: 'dan@turnout.info'
    }
  }, {
    name: 'Jordan Zax',
    role: 'Co-Founder & CTO',
    bio: 'Jordan Zax is the Co-Founder and CTO of Turnout. He previously spent over three years at Palo Alto Networks building enterprise-grade systems and holds his M.S. and B.S. from Northwestern University. Jordan leads engineering and product development.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1pyF3DYVn7xKC9QrAED7EL/1748397385106.jpg',
    social: {
      linkedin: 'https://www.linkedin.com/in/jordan-zax/',
      twitter: 'https://x.com/turnout_info',
      email: 'dan@turnout.info'
    }
  }];
  return <section id="team" className="py-20 bg-gray-50" data-id="element-298">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-299">
        <AnimatedSection data-id="element-300">
          <div className="text-center mb-16" data-id="element-301">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-302">
              Meet Our Team
            </h2>
            <p className="mt-4 max-w-2xl text-xl text-gray-600 mx-auto" data-id="element-303">
              The events team behind lean software and marketing agencies.
            </p>
          </div>
        </AnimatedSection>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-4xl mx-auto" data-id="element-304">
          {teamMembers.map((member, index) => <AnimatedSection key={index} delay={index * 0.2} data-id="element-305">
              <div className="bg-white rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 h-full border border-gray-100" data-id="element-306">
                <div className="aspect-w-3 aspect-h-4 relative" data-id="element-307">
                  <img src={member.image} alt={member.name} className="w-full h-80 object-cover object-center" data-id="element-308" />
                </div>
                <div className="p-8 flex flex-col" data-id="element-309">
                  <h3 className="text-2xl font-bold text-gray-900" data-id="element-310">
                    {member.name}
                  </h3>
                  <p className="text-indigo-600 font-medium mb-4 text-lg" data-id="element-311">
                    {member.role}
                  </p>
                  <p className="text-gray-600 mb-6 flex-grow leading-relaxed" data-id="element-312">
                    {member.bio}
                  </p>
                  <div className="flex space-x-5 mt-auto" data-id="element-313">
                    <a href={member.social.linkedin} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-600 transition-colors" aria-label={`${member.name}'s LinkedIn profile`} data-id="element-314">
                      <Linkedin size={20} data-id="element-315" />
                    </a>
                    <a href={member.social.twitter} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-indigo-600 transition-colors" aria-label={`${member.name}'s Twitter profile`} data-id="element-316">
                      <Twitter size={20} data-id="element-317" />
                    </a>
                    <a href={`mailto:${member.social.email}`} className="text-gray-400 hover:text-indigo-600 transition-colors" aria-label={`Email ${member.name}`} data-id="element-318">
                      <Mail size={20} data-id="element-319" />
                    </a>
                  </div>
                </div>
              </div>
            </AnimatedSection>)}
        </div>
      </div>
    </section>;
}